import React, { FC } from 'react'
import { iconMap } from '@mortgage-pos/ui/utils/customizationHelpers'

export const BankrateSocialFooter: FC = () => {
  return (
    <div className="bankrate-social-footer">
      <h5 className="bankrate-social-footer__title">Follow us:</h5>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.facebook.com/Bankrate"
      >
        <img
          className="bankrate-social-footer__icon"
          src={iconMap('facebook')}
          alt="Facebook"
        />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.instagram.com/Bankrate/"
      >
        <img
          className="bankrate-social-footer__icon"
          src={iconMap('instagram')}
          alt="Instagram"
        />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/company/Bankrate/"
      >
        <img
          className="bankrate-social-footer__icon"
          src={iconMap('linkedIn')}
          alt="LinkedIn"
        />
      </a>
    </div>
  )
}
